export default __webpack_public_path__ + "static/media/infomations_card_icon.476f5165.svg";